export default "__VITE_ASSET__nYCt2MmQ__"